import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import MaterialTable from "material-table";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

let RE_PUBLICATION = new RegExp("([A-Za-z0-9]+) \\((.*)\\)");

let EMERGENCY_ONLY = "emergencyOnly";
let CLINICAL_ONLY = "cinicalOnly";

class TreatmentsTable extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.treatmentData !== nextProps.treatmentData ||
      this.props.stageFilter !== nextProps.stageFilter
    );
  }
  render() {
    return (
      <MaterialTable
        columns={[
          {
            title: "Name",
            field: "name",
            width: "10%",
            cellStyle: (name) =>
              name !== "unnamed" ? { fontWeight: "bold" } : {},
          },
          { title: "Category", field: "product_category", width: "8%" },
          {
            title: "Stage",
            field: "stage",
            width: "7%",
            defaultFilter:
              this.props.stageFilter === CLINICAL_ONLY ? "Clinical" : "",
          },
          { title: "Developer", field: "developer_for_display", width: "20%" },
          {
            title: "Description",
            field: "product_description",
            width: "50%",
          },
          {
            title: "Last Updated",
            field: "date_last_updated",
            width: "10%",
          },
          {
            title: "Emergency Use Auth.",
            field: "has_emerg_use_auth",
            width: "5%",
            defaultFilter:
              this.props.stageFilter === EMERGENCY_ONLY ? "Yes" : "",
          },
        ]}
        data={this.props.treatmentData}
        options={{
          filtering: true,
          padding: "dense",
          search: false,
          showTitle: false,
          toolbar: false,
        }}
        style={{
          boxShadow: "0 0 0 0",
          zIndex: 99,
        }}
        onRowClick={(event, rowData) =>
          this.props.showTreatmentModal(rowData["tableData"]["id"])
        }
      />
    );
  }
}

class TreatmentModal extends Component {
  formatPublishedResults(publishedResult) {
    let matches = publishedResult.match(RE_PUBLICATION);
    if (!matches) {
      return <span>{publishedResult}</span>;
    } else {
      return (
        <a href={matches[2]} target={"_blank"}>
          {matches[1]}
        </a>
      );
    }
  }
  render() {
    let publishedResults = this.props.modalTreatmentData["published_results"];
    if (publishedResults !== "None") {
      publishedResults = (
        <ul>
          {publishedResults.split(", ").map((v) => (
            <li key={v}>{this.formatPublishedResults(v)}</li>
          ))}
        </ul>
      );
    }
    let clinicalTrials = this.props.modalTreatmentData["clinical_trial_id"];
    if (clinicalTrials !== "None") {
      clinicalTrials = (
        <ul>
          {clinicalTrials
            .split(",")
            .map((v) => (v.trim().length === 0 ? "" : <li>{v}</li>))}
        </ul>
      );
    }

    let nextSteps = this.props.modalTreatmentData["next_steps"];
    if (nextSteps !== "Unknown") {
      nextSteps = (
        <ul>
          {nextSteps
            .split(";")
            .map((v) => (v.trim().length === 0 ? "" : <li>{v}</li>))}
        </ul>
      );
    }
    return (
      <Modal
        show={this.props.showModal}
        onHide={this.props.hideTreatmentModal}
        size="lg"
        id="treatment-details"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.modalTreatmentData["name"]} (
            {this.props.modalTreatmentData["product_category"]})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li>
              <b>Stage:</b> {this.props.modalTreatmentData["stage"]}
            </li>
            <li>
              <b>Developer:</b> {this.props.modalTreatmentData["developer"]}
            </li>
            <li>
              <b>Description:</b>{" "}
              {this.props.modalTreatmentData["product_description"]}
            </li>
            <li>
              <b>Next Steps:</b> {nextSteps}
            </li>
            <li>
              <b>Clinical Trials:</b> {clinicalTrials}
            </li>
            <li>
              <b>Published Results:</b> {publishedResults}
            </li>
            <li>
              <b>Funder:</b> {this.props.modalTreatmentData["funder"]}
            </li>
            <li>
              <b>Last Updated:</b>{" "}
              {this.props.modalTreatmentData["date_last_updated"]}
            </li>
          </ul>
        </Modal.Body>
      </Modal>
    );
  }
}

class TreatmentSummary extends Component {
  render() {
    let width = window.innerWidth;
    let customSummaryStyle = {};
    if (width >= 768) {
      customSummaryStyle = { margin: "10px 2em" };
    }
    return (
      <Row className="justify-content-md-center">
        <div
          className={`circle text-center align-middle ${
            this.props.stageFilter === CLINICAL_ONLY ? "active" : ""
          }`}
          onClick={() =>
            this.props.stageFilter === CLINICAL_ONLY
              ? this.props.setStageFilter("")
              : this.props.setStageFilter(CLINICAL_ONLY)
          }
          style={customSummaryStyle}
        >
          <p>
            <span className="statNumber">{this.props.numClinical}</span>
            <br />
            <span className="statDescription">in Clinical Studies</span>
          </p>
        </div>
        <div
          className={`circle text-center align-middle ${
            this.props.stageFilter === EMERGENCY_ONLY ? "active" : ""
          }`}
          onClick={() =>
            this.props.stageFilter === EMERGENCY_ONLY
              ? this.props.setStageFilter("")
              : this.props.setStageFilter(EMERGENCY_ONLY)
          }
          style={customSummaryStyle}
        >
          <p>
            <span className="statNumber">{this.props.numEmerg}</span>
            <br />
            <span className="statDescription">
              Authorized for Emergency Use
            </span>
          </p>
        </div>
      </Row>
    );
  }
}

class Treatments extends Component {
  state = {
    showModal: false,
    stageFilter: "",
    treatmentData: [],
    modalTreatmentData: {
      name: "unnamed",
      product_category: "Unknown",
      stage: "Unknown",
      product_description: "None",
      next_steps: "Unknown",
      funder: "None",
      clinical_trial_id: "None",
      published_results: "None",
      date_last_updated: "None",
    },
    numClinical: 0,
    numEmerg: 0,
  };

  constructor(props) {
    super(props);
    this.hideTreatmentModal = this.hideTreatmentModal.bind(this);
    this.showTreatmentModal = this.showTreatmentModal.bind(this);
    this.setStageFilter = this.setStageFilter.bind(this);
  }

  componentDidMount() {
    fetch("/api/treatments")
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          treatmentData: data["data"]["raw"],
          numClinical: data["data"]["metadata"]["num_clinical"],
          numEmerg: data["data"]["metadata"]["num_emerg_use_auth"],
        });
      })
      .catch(console.log);
  }

  hideTreatmentModal() {
    this.setState({ showModal: false });
  }

  showTreatmentModal(rowId) {
    let data = this.state.treatmentData[rowId];
    if (data["published_results"] === "Unknown") {
      data["published_results"] = "None";
    }
    this.setState({ showModal: true, modalTreatmentData: data });
  }

  setStageFilter(value) {
    this.setState({ stageFilter: value });
  }

  render() {
    document.title = "COVID Dashboard - Treatments";
    if (this.state.treatmentData.length === 0) {
      return (
        <div>
          <h3 className="pageTitle">COVID-19 Treatment Tracker</h3>
          <div id="treatment-loading-icon">
            <FontAwesomeIcon icon={faSpinner} id="loading-icon" spin />
          </div>
        </div>
      );
    }

    let dataSourceStatement =
      "Data from FasterCures, a center of the Milken Institute.";

    return (
      <div>
        <h3 className="pageTitle">COVID-19 Treatment Tracker</h3>
        <h5 className="pageSubtitle">(Data as of April 1, 2021)</h5>
        <TreatmentSummary
          numClinical={this.state.numClinical}
          numEmerg={this.state.numEmerg}
          stageFilter={this.state.stageFilter}
          setStageFilter={this.setStageFilter}
        />
        <TreatmentsTable
          treatmentData={this.state.treatmentData}
          stageFilter={this.state.stageFilter}
          showTreatmentModal={this.showTreatmentModal}
        />
        <br />
        <Row id="data-source-statement">
          <small className="text-muted">{dataSourceStatement}</small>
        </Row>
        <TreatmentModal
          showModal={this.state.showModal}
          modalTreatmentData={this.state.modalTreatmentData}
          hideTreatmentModal={this.hideTreatmentModal}
        />
      </div>
    );
  }
}

export { Treatments };



// WEBPACK FOOTER //
// ./src/_treatments.js